module.exports = __webpack_public_path__ + "img/logo.b02936b8.png";